// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2HUA1","footer":"ModalError_footer__TlsS8"};